import { Dialog } from "@headlessui/react";
import { useTranslation } from "react-i18next";
import DialogBackdrop from "../../../ModalDialogs/DialogBackdrop";
import { useSelector } from "react-redux";
import { deactivateUser } from "../../../../service/userservice/deactivateUser";
export default function AssistantTerminateDialog({
  dialogState,
  setDialogState,
  datafirstname,
  datalastname,
  datauserid,
  getuserPermissions,
  setPageLoad,
}) {
  const { csrUser } = useSelector((s) => s.csrUser);
  const { t } = useTranslation();

  async function userDeactivate() {
    if (csrUser?.userId) {
      alert(t("AssistantTerminateDialog-deactivateAlert"));
      return;
    }
    await deactivateUser(datauserid).catch((error) => {
      console.log(error);
    });
    setPageLoad(0);
    getuserPermissions();
    setDialogState(false);
  }

  return (
    <Dialog
      open={dialogState}
      onClose={() => setDialogState(false)}
      className="ui-dialogs"
    >
      <DialogBackdrop />
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel
          role="dialog"
          aria-modal="true"
          className="ui-default-dialog"
        >
          <Dialog.Title className="dialog_label2 font-body text-xl font-bold text-left">
            {t("AgentAssistantTerminateDialog-dialogTitle")}
          </Dialog.Title>
          <button
            className="ui-default-dialog-close"
            onClick={() => setDialogState(false)}
          >
            <svg
              className="ui-icon h-3.5 w-3.5"
              focusable="false"
              aria-hidden="true"
              role="presentation"
            >
              <use href="#ui-icon-close"></use>
            </svg>
          </button>
          <hr />
          <Dialog.Description as="div">
            <div className="text-sm font-semibold mx-auto w-full md:w-4/5">
              <div className="text-xs font-normal">
                {t("AgentAssistantTerminateDialog-dialogDescription")}
                {datafirstname} {datalastname}?
              </div>
            </div>
          </Dialog.Description>

          <div className="block text-right mt-6">
            <button
              className="ui-btn-secondary ui-btn-min-w mt-4"
              onClick={() => setDialogState(false)}
            >
              {t("AgentAssistantTerminateDialog-cancelButton")}
            </button>
            <button
              className="ui-btn-primary ui-btn-min-w mt-4"
              onClick={() => {
                userDeactivate();
              }}
            >
              {t("AgentAssistantTerminateDialog-terminateButton")}
            </button>
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
}
